<template>
    <form @submit.prevent="proceed" @keydown="cohortForm.errors.clear($event.target.name)">
        <div class="row">
            <div class="col-12 col-sm-12">
                <div class="form-group">
                    <label for="">Name</label>
                    <input class="form-control" :class="{ 'is-invalid': cohortForm.errors.has('name') }" type="text" value="" v-model="cohortForm.name" name="name" placeholder="Name">
                    <show-error :form-name="cohortForm" prop-name="name"></show-error>
                </div>
            </div>
        </div>
        <button type="submit" class="btn btn-primary mr-1 mb-1 waves-effect waves-light pull-right">
            <span v-if="id">{{trans('general.update')}}</span>
            <span v-else>{{trans('general.save')}}</span>
        </button>
        <router-link to="/cohort" class="btn btn-danger waves-effect waves-light pull-right mr-1 mb-1" v-show="id">{{trans('general.cancel')}}</router-link>
        <button v-if="!id" type="button" class="btn btn-danger waves-effect waves-light pull-right mr-1 mb-1" @click="$emit('cancel')">{{trans('general.cancel')}}</button>
    </form>
</template>


<script>
    export default {
        data() {
            return {
                cohortForm: new Form({
                    name : ''
                })
            };
        },
        props: ['id'],
        mounted() {
            if(this.id)
                this.getBatch();
        },
        methods: {
            proceed(){
                if(this.id)
                    this.updateBatch();
                else
                    this.storeBatch();
            },
            storeBatch(){
                this.cohortForm.post('/api/setting/cohort')
                    .then(response => {
                        toastr.success(response.message);
                        this.$emit('completed')
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
            getBatch(){
                axios.get('/api/setting/cohort/'+this.id)
                    .then(response => response.data)
                    .then(response => {
                        this.cohortForm.name = response.name;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                        this.$router.push('/setting/cohort');
                    });
            },
            updateBatch(){
                this.cohortForm.patch('/api/setting/cohort/'+this.id)
                    .then(response => {
                        toastr.success(response.message);
                        this.$router.push('/setting/cohort');
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            }
        }
    }
</script>
